
import { Component, Vue, Watch } from 'vue-property-decorator'
import SubMenu from '@/components/menu/SubMenu.vue'
import { useAppStore } from '@/store/app'
import { useMenuStore } from '@/store/menu'

const appStore = useAppStore()
const menuStore = useMenuStore()

@Component({
  components: { SubMenu },
})
export default class AdminSidebar extends Vue {
  private openKeys: string[] = []
  private selectedKeys: string[] = []
  private appStore = appStore

  private menuToLinksDictionary: any = {}
  private menuToIdsDictionary: any = {}

  @Watch('$route')
  private changeSelected() {
    const find = this.menuToLinksDictionary[this.$route.path]
    if (find) {
      this.selectedKeys = [`menu-item-${find.id}`]

      if (find.pid) {
        const parents = this.findParent(find.id)
        this.openKeys = parents.reverse().map((v: any) => `submenu-${v}`)
      }
    }
  }
  @Watch('menus')
  private menuChange() {
    this.init()
    this.changeSelected()
  }

  private get menus() {
    return this.filterMenu(menuStore.menu)
  }

  private mounted() {
    this.init()
  }
  private init() {
    const temp = this.flat(menuStore.menu, 0)
    this.menuToIdsDictionary = this.convertArrayToObject({
      arr: temp,
      key: 'id',
      whole: true,
    })
    this.menuToLinksDictionary = this.convertArrayToObject({
      arr: temp,
      key: 'link',
      whole: true,
    })
  }

  private change(e: any[]) {
    if (e.length) {
      const current = e.pop()
      const parents = this.findParent(current.split('-').pop())
      let keys = parents
        .reverse()
        .map((v: any) => `submenu-${v}`)
        .concat(current)

      // 当用户展开多级菜单时，点击最上级菜单，会出现查找父级菜单链补全已关闭父菜单问题
      // 因此需判断点击菜单是否为顶级子菜单
      if (this.openKeys.length === keys.length) {
        const remain = keys.filter((v, index) => {
          return v !== this.openKeys[index]
        })

        // 如果查找出来的父级菜单链接与当前打开链接一致，那么可以认为用户关闭了顶级子菜单
        if (!remain.length) {
          keys = []
        }
      }

      this.openKeys = keys
    } else {
      this.openKeys = []
    }
  }

  private selected({ selectedKeys }) {
    this.selectedKeys = selectedKeys
  }

  private flat(arr: any[], pid: number | string): any[] {
    return arr.reduce((a, b) => {
      b.pid = pid
      a = a.concat(b)

      if (b.children && b.children.length) {
        a = a.concat(this.flat(b.children, b.id))
      }

      return a
    }, [])
  }

  private findParent(id: string | number, arr: any[] = []) {
    const found = this.menuToIdsDictionary[id]
    if (found && found.pid && !this.menuToIdsDictionary[found.pid].group) {
      arr.push(found.pid)

      return this.findParent(found.pid, arr)
    } else {
      return arr
    }
  }

  private filterMenu(menu: any[]) {
    const data: any[] = []
    for (const item of menu) {
      if (item.show && item.text !== '系统首页') {
        data.push(item)
      }

      if (item.children && item.children.length > 0) {
        item.children = item.children.filter((subItem) => subItem.show)
        this.filterMenu(item.children)
      }
    }
    return data
  }
  private convertArrayToObject(config): object {
    const { arr, key, whole, containsKeys } = Object.assign({ whole: false, containsKeys: '' }, config)

    if (Array.isArray(arr) && Object.keys(arr).length > 0) {
      return arr.reduce((a, needle) => {
        const kIndex: any = this.searchIndexByKey(key, needle)

        if (kIndex) {
          let value: any = {}

          if (!whole || !!containsKeys) {
            if (Array.isArray(containsKeys)) {
              containsKeys.forEach((ckey: any) => {
                value[ckey] = needle[ckey]
              })
            } else if (containsKeys) {
              value = needle[containsKeys]
            }
          } else {
            value = needle
          }

          a[kIndex] = value
        }

        return a
      }, {})
    }

    return {}
  }
  private searchIndexByKey(key: string | string[], needle: any): any {
    let index: any = ''

    if (Array.isArray(key)) {
      index = key.reduce((res, k) => {
        return needle[k] || res
      }, index)
    } else {
      index = needle[key]
    }
    return index
  }
}
